import { render, staticRenderFns } from "./TierBenefit.vue?vue&type=template&id=28409e22&scoped=true&"
import script from "./TierBenefit.vue?vue&type=script&lang=js&"
export * from "./TierBenefit.vue?vue&type=script&lang=js&"
import style0 from "./TierBenefit.vue?vue&type=style&index=0&id=28409e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28409e22",
  null
  
)

export default component.exports